/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as BitmapWordDeployerContractJson } from "../BitmapWordDeployer.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import * as types from "./types";

// Custom types for the contract
export namespace BitmapWordDeployerTypes {
  export type State = Omit<ContractState<any>, "fields">;

  export interface CallMethodTable {
    deploy: {
      params: CallContractParams<{ payer: Address }>;
      result: CallContractResult<HexString>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    deploy: {
      params: SignExecuteContractMethodParams<{ payer: Address }>;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];
}

class Factory extends ContractFactory<BitmapWordDeployerInstance, {}> {
  encodeFields() {
    return encodeContractFields({}, this.contract.fieldsSig, types.AllStructs);
  }

  at(address: string): BitmapWordDeployerInstance {
    return new BitmapWordDeployerInstance(address);
  }

  tests = {
    deploy: async (
      params: Omit<
        TestContractParamsWithoutMaps<never, { payer: Address }>,
        "initialFields"
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "deploy", params, getContractByCodeHash);
    },
  };

  stateForTest(initFields: {}, asset?: Asset, address?: string) {
    return this.stateForTest_(initFields, asset, address, undefined);
  }
}

// Use this object to test and deploy the contract
export const BitmapWordDeployer = new Factory(
  Contract.fromJson(
    BitmapWordDeployerContractJson,
    "",
    "082de32f22857e094db5658611a1d2ba23e792a7f23a548525e6de2784f2a70b",
    types.AllStructs
  )
);
registerContract(BitmapWordDeployer);

// Use this class to interact with the blockchain
export class BitmapWordDeployerInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  async fetchState(): Promise<BitmapWordDeployerTypes.State> {
    return fetchContractState(BitmapWordDeployer, this);
  }

  view = {
    deploy: async (
      params: BitmapWordDeployerTypes.CallMethodParams<"deploy">
    ): Promise<BitmapWordDeployerTypes.CallMethodResult<"deploy">> => {
      return callMethod(
        BitmapWordDeployer,
        this,
        "deploy",
        params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    deploy: async (
      params: BitmapWordDeployerTypes.SignExecuteMethodParams<"deploy">
    ): Promise<BitmapWordDeployerTypes.SignExecuteMethodResult<"deploy">> => {
      return signExecuteMethod(BitmapWordDeployer, this, "deploy", params);
    },
  };

  async multicall<Calls extends BitmapWordDeployerTypes.MultiCallParams>(
    calls: Calls
  ): Promise<BitmapWordDeployerTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends BitmapWordDeployerTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<BitmapWordDeployerTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | BitmapWordDeployerTypes.MultiCallParams
      | BitmapWordDeployerTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      BitmapWordDeployer,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
